import {useEffect, useRef, useState} from 'react';
import './LazyImage.css';

export default function LazyImage({src, className = '', alt = '', forceLoad = false, ...props}) {
    const imageRef = useRef(null);
    const [shouldLoad, setShouldLoad] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (forceLoad) setShouldLoad(true);
    }, [forceLoad]);

    useEffect(() => {
        const image = imageRef.current;
        if (!image || forceLoad) return undefined;

        if (!('IntersectionObserver' in window)) {
            setShouldLoad(true);
            return undefined;
        }

        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                setShouldLoad(true);
                observer.disconnect();
            }
        }, {rootMargin: '300px 200px', threshold: 0});

        observer.observe(image);
        return () => observer.disconnect();
    }, [forceLoad]);

    return <img
        ref={imageRef}
        src={shouldLoad ? src : undefined}
        className={`lazy-image ${loaded ? 'lazy-image--loaded' : ''} ${className}`.trim()}
        alt={alt}
        decoding="async"
        onLoad={() => setLoaded(true)}
        {...props}
    />;
}
